import React, { useEffect, useState, useCallback } from 'react';
import { DataGrid } from '../../common/Components';
import MaterialTableCS from '../../common/ComponentesCS/MaterialTableCS';
import { ClientService } from '../../common/services';
import { useHistory, useLocation } from 'react-router';
import { useStylesGeneral } from '../../styles/StyleComponents';
import "../../styles/site.css";
import Filters from './components/Filters';
import TextTitleCS from '../../common/ComponentesCS/TextTitleCS';
import { Button, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CreateProjectDialog from './components/CreateProjectDialog';
// import { useStylesGeneral } from '../../styles/StyleComponents';
// import MaterialTableCSCustom from '../../common/ComponentesCS/MaterialTableCSCustom';
// import { ClientService } from '../../common/services/client.service';

const tableActionButtonStyle = {
    backgroundColor: '#1976d2',
    color: 'white',
    padding: '5px 10px',
    fontSize: '12px',
    textTransform: 'none'
};

const Projects = (props) => {
    const location = useLocation();
    const clientData = location.state?.project;

    const [clientsProjects, setClientsProjects] = useState([]);
    const [originalClientsProjects, setOriginalClientsProjects] = useState([]); // Datos originales sin filtrar
    const [loading, setLoading] = useState(true);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const history = useHistory();
    const classes = useStylesGeneral();

    const getWizardInitialStep = (projectStatus) => {
        const normalizedStatus = `${projectStatus || ''}`.trim().toLowerCase();

        if (normalizedStatus === 'configuracion') {
            return 2;
        }

        if (normalizedStatus === 'confirmado') {
            return 3;
        }

        if (normalizedStatus === 'concluido') {
            return 4;
        }

        return 0;
    };

    // Configuración de columnas para la tabla
    const columns = [
        {
            field: 'idProyecto',
            title: 'ID Proyecto',
        },
        {
            field: 'nombreProyecto',
            title: 'Nombre Proyecto',
        },
        {
            field: 'cliente',
            title: 'Cliente',
        },
        {
            title: 'Nombre Cliente',
            field: 'nombre',
        },
        {
            field: 'tipoProyecto',
            title: 'Tipo Proyecto',
        },
        {
            title: 'Estatus',
            field: 'estatusProyecto',
        },
        {
            field: 'Ingresar',
            title: 'Ingresar',
            sorting: false,
            render: (rowData) => (
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                        const initialStep = getWizardInitialStep(rowData?.estatusProyecto);

                        history.push({
                            pathname: '/Home/projects/details',
                            state: {
                                project: rowData,
                                initialStep
                            }
                        });
                    }}
                    style={tableActionButtonStyle}
                >
                    Ingresar
                </Button>
            )
        }
    ];

    // Función para obtener proyectos (reutilizable)
    const fetchClientsProjects = async () => {
        try {
            setLoading(true);
            const response = await ClientService.getClientsProjects(clientData?.cliente);
            setOriginalClientsProjects(response); // Guardar datos originales
            setClientsProjects(response);
        } catch (error) {
            setOriginalClientsProjects([]);
            setClientsProjects([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchClientsProjects();
    }, [clientData]);

    // Función para aplicar filtros a los datos
    const applyFilters = useCallback((filters) => {
        let filteredData = [...originalClientsProjects];

        // Filtrar por ID Proyecto
        if (filters.idProyecto && filters.idProyecto.trim() !== '') {
            filteredData = filteredData.filter(project =>
                project.idProyecto && project.idProyecto.toString().toLowerCase().includes(filters.idProyecto.toLowerCase())
            );
        }

        // Filtrar por Nombre Proyecto
        if (filters.nombreProyecto && filters.nombreProyecto.trim() !== '') {
            filteredData = filteredData.filter(project =>
                project.nombreProyecto && project.nombreProyecto.toLowerCase().includes(filters.nombreProyecto.toLowerCase())
            );
        }

        // Filtrar por Cliente
        if (filters.cliente && filters.cliente.trim() !== '') {
            filteredData = filteredData.filter(project =>
                project.cliente && project.cliente.toLowerCase().includes(filters.cliente.toLowerCase())
            );
        }

        // Filtrar por Tipo Proyecto
        if (filters.tipoProyecto && filters.tipoProyecto.trim() !== '') {
            filteredData = filteredData.filter(project =>
                project.tipoProyecto && project.tipoProyecto.toLowerCase().includes(filters.tipoProyecto.toLowerCase())
            );
        }

        // Filtrar por Estatus
        if (filters.estatusProyecto && filters.estatusProyecto.trim() !== '') {
            filteredData = filteredData.filter(project =>
                project.estatusProyecto && project.estatusProyecto.toLowerCase().includes(filters.estatusProyecto.toLowerCase())
            );
        }

        setClientsProjects(filteredData);
    }, [originalClientsProjects]);

    // Función para limpiar filtros
    const clearFilters = useCallback(() => {
        setClientsProjects(originalClientsProjects);
    }, [originalClientsProjects]);

    // Manejar cambios de filtros
    const handleFiltersChange = useCallback((newFilters) => {
        applyFilters(newFilters);
    }, [applyFilters]);

    // Funciones para manejar la modal
    const handleOpenCreateModal = () => {
        setShowCreateModal(true);
    };

    const handleCloseCreateModal = () => {
        setShowCreateModal(false);
    };

    // Función para manejar éxito en creación de proyecto
    const handleProjectCreated = () => {
        setSnackbar({
            open: true,
            message: 'Proyecto creado exitosamente',
            severity: 'success'
        });
        setShowCreateModal(false);
        fetchClientsProjects(); // Actualizar la lista de proyectos
    };

    // Función para manejar error en creación de proyecto
    const handleProjectCreationError = (errorMsg) => {
        setSnackbar({
            open: true,
            message: errorMsg || 'Error al crear el proyecto',
            severity: 'error'
        });
        setShowCreateModal(false);
    };

    // Función para cerrar el snackbar
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ open: false, message: '', severity: 'success' });
    };

    return (
        <div className={`${classes.root}`} style={{ display: 'flex', flexDirection: 'column', height: '100%', padding: '20px' }}>
            <TextTitleCS title={clientData ? `Proyectos de ${clientData.nombre}`.toUpperCase() : "Lista de Proyectos"} />
            <div style={{ display: 'flex', flexDirection: 'row', padding: '10px', gap: '15px', alignSelf: 'flex-end' }}>
                <Button className="botonAzul floatLeft" onClick={handleOpenCreateModal} variant="contained">Crear Proyecto</Button>

            </div>
            <Filters
                onFiltersChange={handleFiltersChange}
                onClearFilters={clearFilters}
            />
            <MaterialTableCS
                data={clientsProjects}
                columns={columns}
                title=""
                pageSize={10}
                showTitle={false}
                selection={false}
                actions={[]}
                pageSizeOptions={[5, 10, 25, 50]}
                toolbar={false}
                search={true}
                paging={true}
                loading={loading}
            />

            {/* Modal para crear proyecto */}
            <CreateProjectDialog
                show={showCreateModal}
                onClose={handleCloseCreateModal}
                onProjectCreated={handleProjectCreated}
                onProjectCreationError={handleProjectCreationError}
                clientData={clientData}
            />

            {/* Snackbar para notificaciones */}
            <Snackbar
                className="app-toast"
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default Projects;
